import React from "react";
export default (props) => {
    return (React.createElement("div", { "data-ecom-alert": "error" },
        React.createElement("div", { className: "alert-icon-section" },
            React.createElement("div", { className: "alert-icon" },
                React.createElement("i", { className: "icon-exclamation no-margin" }))),
        React.createElement("div", { className: "alert-content" }, props.message)));
};
